export const convertStrToSlug = (str) => str.toLowerCase().replace(/\s+/g, "-");
